<template>
    <div class="hello">
        <!-- <div class="dates" >
            <input type="date" v-model="today">
        </div> -->
        <div class="mobile-reports">
            <div class="welcome">
                <span>ברוך הבא,</span>
                <b>{{ $root.loggedUser.firstName }}</b>
            </div>
            <div class="reports">
                <div class="reports-list">
                    <div class="reports-item">
                        <div class="report-title">
                            סך הזמנות היום
                        </div>
                        <div class="report-data">
                            {{totalOrdersForToday}}
                        </div>
                    </div>
                    <div class="reports-item">
                        <div class="report-title">
                            סה"כ מכירות היום
                        </div>
                        <div class="report-data">
                            ₪{{subTotalForToday}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="quick-actions">
                <div class="quick-title">
                    קיצורי דרך
                </div>
                <div class="actions-list" @click="goToRoute('/newOrderbeta')">
                    <div class="action-item">
                        <div class="action-box">
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-bag-icon lucide-shopping-bag"><path d="M16 10a4 4 0 0 1-8 0"/><path d="M3.103 6.034h17.794"/><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/></svg>                        </div>
                        <span>הזמנה חדשה</span>
                    </div>
                    <div class="action-item" v-if="$root.loggedUser.Type == 'Admin'">
                        <div class="action-box">
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-banknote-arrow-up-icon lucide-banknote-arrow-up"><path d="M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5"/><path d="M18 12h.01"/><path d="M19 22v-6"/><path d="m22 19-3-3-3 3"/><path d="M6 12h.01"/><circle cx="12" cy="12" r="2"/></svg>                        </div>
                        <span>הוצאה חדשה</span>
                    </div>
                    <div class="action-item" v-if="$root.loggedUser.Type == 'Admin'">
                        <div class="action-box">
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-round-plus-icon lucide-user-round-plus"><path d="M2 21a8 8 0 0 1 13.292-6"/><circle cx="10" cy="8" r="5"/><path d="M19 16v6"/><path d="M22 19h-6"/></svg>                        </div>
                        <span>ספק חדש</span>
                    </div>
                    <div class="action-item" v-if="$root.loggedUser.Type == 'Admin'">
                        <div class="action-box">
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off-icon lucide-eye-off"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/><path d="m2 2 20 20"/></svg>                        </div>
                        <span>מתכון חדש</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="statics" v-if="$root.loggedUser.Type == 'Admin'">
            <div class="box" id="box">
                <div class="iconBox">
                    <i class="material-icons">shopping_bag</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">סה"כ הזמנות היום</span>
                    <span class="ordersCount">{{totalOrdersForToday}}</span>
                </div>
                <router-link to="/Orders" class="staticBtn">
                    <span>מעבר להזמנות</span>
                </router-link>
            </div>
            <div class="box" v-if="$root.loggedUser.Type == 'Admin'">
                <div class="iconBox">
                    <i class="material-icons">sell</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">סה"כ מכירות היום</span>
                    <span class="ordersCount">{{subTotalForToday}} <span style="font-size: 14px; color: #707070;">₪</span></span> 
                    
                </div>
                <router-link to="" class="staticBtn">
                    <span>מעבר למכירות</span>
                </router-link>
            </div>
            <div class="box" v-else>
                <div class="iconBox">
                    <i class="material-icons">block</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">אין לך גישה</span>
                    
                </div>
            </div>
            <div class="box" v-if="$root.loggedUser.Type == 'Admin'">
                <div class="iconBox">
                    <i class="material-icons">shopping_cart_checkout</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">הוצאות</span>
                    <span class="ordersCount">{{ 0 }} <span style="font-size: 14px; color: #707070;">₪</span></span>
                </div>
                <router-link to="" class="staticBtn">
                    <span>מעבר להוצאות</span>
                </router-link>
            </div>
            <div class="box" v-else>
                <div class="iconBox">
                    <i class="material-icons">block</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">אין לך גישה</span>
                    
                </div>
            </div>
            <div class="box" v-if="$root.loggedUser.Type == 'Admin'">
                <div class="iconBox">
                    <i class="material-icons">groups</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">ספקים</span>
                    <span class="ordersCount">{{ dealersCount }}</span>
                </div>
                <router-link to="/Suppliers" class="staticBtn">
                    <span>מעבר לספקים</span>
                </router-link>
            </div>
             <div class="box" v-else>
                <div class="iconBox">
                    <i class="material-icons">block</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">אין לך גישה</span>
                    
                </div>
            </div>
        </div>
        <div class="section2" v-if="$root.loggedUser.Type == 'Admin'">


            <div class="stockData">
                <div class="iconBox">
                    <i class="material-icons stockIcon" >inventory_2</i>
                </div>
                <div class="overviewText">
                    <span class="titleText">פריטים עם מלאי נמוך</span>
                    <span class="ordersCount" style="color: #d11a2a;">{{this.lowStock}}</span>
                </div>

                <div class="stockList">
                    <div class="itemList">
                        עוגה מרובעת 5 פסים
                    </div>
                    <div class="itemList">
                        test
                    </div>
                    <div class="itemList">
                        test
                    </div>
                </div>
            </div>


            <div class="lastPayments" v-if="$root.loggedUser.Type == 'Admin'">
                <div class="header">
                    <div class="icon">
                        <i class="material-icons">shopping_cart_checkout</i>
                    </div>
                    <span class="text">הוצאות אחרונות</span>
                    <div class="searchDiv">
                        <input type="text" placeholder="חיפוש בהוצאות">
                    </div>
                </div>
                <table>
                    <tr>
                        <th>הוצאה עבור</th>
                        <th>תאריך</th>
                        <th>סכום</th>
                    </tr>
                    <tr v-for="(expense, index) in expenses" :id="expense.ID" :index="index">
                        <td>{{ expense.Data.dealerName }}</td>
                        <td>{{ expense.Data.date }}</td>
                        <td>₪{{ expense.Data.amount }}</td>
                    </tr>
                </table>
            </div>

        </div>

        <div class="section3">

            <div class="lastOrders">
                <div class="header">
                    <div class="icon">
                        <i class="material-icons">shopping_bag</i>
                    </div>
                    <span class="text">הזמנות אחרונות</span>
                    <div class="searchDiv">
                        <input type="text" placeholder="חיפוש הזמנות">
                    </div>
                </div>
                <table>
                    <tr>
                        <th>מספר</th>
                        <th>שם</th>
                        <th>מספר טלפון</th>
                        <th>יום</th>
                        <th>תאריך</th>
                        <th>שעה</th>
                        <th>סטטוס</th>
                        <th>סכום</th>
                        <th>גבייה</th>
                        <th></th>
                    </tr>
                    <tr v-for="order in orders" v-if="order.Data.status != 'נמחקה'">
                        <td>#{{ order.Data.orderNumber }}</td>
                        <td>{{ order.Data.fullname }}</td>
                        <td>{{ order.Data.phoneNumber }}</td>
                        <td>{{ order.Data.dayOrder }}</td>
                        <td>{{ order.Data.dateOrder }}</td>
                        <td>{{ order.Data.timeOrder }}</td>
                        <td>{{ order.Data.status }}</td>
                        <td>{{ order.Data.totalOrderPrice }}</td>
                        <td>{{ order.Data.paidStatus }}</td>
                        <td></td>
                    </tr>
                    
                </table>
            </div>

        </div>
    </div>
  </template>
  <script >
    import { db } from '../firebase';
    import firebase from "firebase/app";
    import order from '../components/Order.vue';
    import moment from 'moment';

    import "firebase/auth";
    import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'
  export default {
    name: 'Home',
    // props :['order', 'rowIndex'],
    components :{
         order,

        },
    data () {
      return {
        orders : [],
        Dealers:[],
        // order: {
        //     fullname: '',
        //     phoneNumber: '',
        //     cakeTaste: '',
        //     cakeSize: '',
        //     dateOrder: '',
        //     timeOrder: '',
        //     dayOrder: '',
        //     priceOrder: '',
        //     createdDate: '',
        // },
        modalShow: false,
        activeOrder : null,
        today: moment().format("YYYY-MM-DD"),
        orderCounterID:{
            counterID:null,
            orderCreatedDate:moment().format('LLLL')
        },
        totalOrdersForToday:0,
        subTotalForToday:0,
        dealersCount:0,
        lowStock:0,
        totalExpenses:0,
        expenses:[],
        deletedOrdersCounter:0,

      }
    },
    
    created(){
        let vm = this;
        vm.today = moment().format("YYYY-MM-DD");  
        vm.loadOrders();  
        vm.loadTotalCounterOrders();
        vm.loadDealers();
        vm.loadLowStock();
        vm.loadTotalExpenses();
        vm.loadExpenses();
        console.log(moment().format('LTS'))
            
    },
    methods : {
        goToRoute(route){
            this.$router.push(route)
        },
        loadDealers(){
          let vm = this;
          vm.Dealers = [];
          db.collection("Dealers").where("type", "==", "ספק").onSnapshot((DealerMeheron) => {
                  for(let a = 0; a < DealerMeheron.size; a++){
                      let dealerId = DealerMeheron.docs[a].id;
                      let dealer = DealerMeheron.docs[a].data();
                    //   console.log(DealerMeheron.size);
                      vm.dealersCount = DealerMeheron.size;
                      
                      
                      vm.Dealers.push({ ID: dealerId, Data: dealer });
                     
              }
        //   })
        //   .catch(function(error){
        //       console.log("Error getting document:", error);
      });
      },
        loadOrders(){
          let vm = this;
          vm.orders = [];
          db.collection("orders").orderBy("orderNumber","desc").limit("10").get()
          .then(function(orderResult){
                  for(let a = 0; a < orderResult.size; a++){
                      let orderId = orderResult.docs[a].id;
                      let order = orderResult.docs[a].data();
                      vm.orders.push({ ID: orderId, Data: order });
              }
          })
          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      loadTotalCounterOrders(){
          let vm = this;
          db.collection("orders").where("dateOrder", ">=",vm.today).where("dateOrder","<=",vm.today).get()
          .then(function(orderResult){
                  for(let a = 0; a < orderResult.size; a++){
                      let orderId = orderResult.docs[a].id;
                      let order = orderResult.docs[a].data();
                      vm.totalOrdersForToday = orderResult.size;
                      if(order.status == 'נמחקה'){
                        vm.deletedOrdersCounter++;   
                      }
                      
                        vm.totalOrdersForToday = vm.totalOrdersForToday - vm.deletedOrdersCounter; 
                      

                      vm.subTotalForToday = vm.subTotalForToday += order.totalOrderPrice;                    
              }
          })
          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      loadTotalExpenses(){
          let vm = this;
          vm.orders = [];
          db.collection("cheques").get()
          .then(function(expenseResult){
                  for(let a = 0; a < expenseResult.size; a++){
                      let expenseId = expenseResult.docs[a].id;
                      let expense = expenseResult.docs[a].data();
                      vm.totalExpenses = vm.totalExpenses += expense.amount;
                    

              }
          })
          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      loadExpenses(){
          let vm = this;
          vm.orders = [];
          db.collection("Expenses").limit("5").orderBy("createdDate","desc").get()
          .then(function(expenseResult){
                  for(let a = 0; a < expenseResult.size; a++){
                      let expenseId = expenseResult.docs[a].id;
                      let expense = expenseResult.docs[a].data();
                    //   vm.totalExpenses = expenseResult.size;
                      vm.expenses.push({ ID: expenseId, Data: expense });
                    

              }
          })
          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      loadLowStock(){
          let vm = this;
          vm.orders = [];
          db.collection("Products").where('Quantity', '<=', 3).get()
          .then(function(ProductResult){
                  for(let a = 0; a < ProductResult.size; a++){
                      let orderId = ProductResult.docs[a].id;
                      let order = ProductResult.docs[a].data();
                      // console.log(orderResult.size);
                      vm.lowStock = ProductResult.size;
                    //   console.log("Orders Count Is : " + orderResultcount);
                    //   vm.orders.push({ ID: orderId, Data: order });
                    //   vm.subTotalForToday = vm.subTotalForToday += order.totalOrderPrice;
                    //   console.log(vm.subTotalForToday , "Total")
                    

              }
          })
          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      pushOrderID(){
        let vm = this;
        
        vm.orderCounterID = {
            counterID: vm.counterID+=1,
             orderCreatedDate:moment().format('LLLL')
         }
         db.collection("CounterID").set(vm.orderCounterID).then((orderResultID) => {
             vm.orderCounterID = {
             counterID: counterID+=1,
             orderCreatedDate:moment().format('LLLL')
         }
        //  console.log(orderResultID);
            
            // console.log("Success")
         }).catch(() => {
             console.log(error, "Error Adding Counter to Firebase")
         })
      },
      loadOrderID(){
          let vm = this;
          db.collection("CounterID").get()
          .then(function(orderResultID){
                  for(let a = 0; a < orderResultID.size; a++){
                      let orderId = orderResultID.docs[a].id;
                      let order = orderResultID.docs[a].data();
                    //   console.log(orderResultID.size);
                      vm.orders.push(
                        { 
                            ID: orderId, Data: order 
                        }
                        );
              }
          })
          .catch(function(error){
              console.log("Error getting document:", error);
      });
      },
       
        }
    }

  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style >
  .hello{
    height: 100%;
    margin-top: 1rem;
  }
  h1, h2 {
    font-weight: normal;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {
    display: inline-block;
    margin: 0 10px;
  }
  
  a {
    color: #35495E;
  }
  .light-orange{
    background-color: transparent;
  }
  .green{
    background-color: #f9f9f9;
  }
.modal-header{
    background-color: #fcfcfc;
    color: #666;
}
.modal-header .close{
    border: none;
    font-size: 22px;
    color: #666;
    background-color: transparent;
}
.modal-footer{
    display: none;
}
.panel{
    background-color: #fff;
    padding: 1rem;
    width: 100%;
    display: flex;
    align-items: flex-start;
}
.panel .ordersPanel{
    width: 60%;
    min-height: 200px;
    background-color:#fff;
    border-radius: 8px;
    border: 1px solid #eee;
    margin: 0 5px;
}
.panel .notesPanel{
    width: 40%;
    min-height: 200px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #eee;
    margin: 0 5px;
}
.ordersPanel .panelOrdersTitle , .panelnotesTitle{
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    background-color: #fcfcfc;
    padding:  0 1rem;
    color: #666666;
}
.mobile-reports{
    display: none;
}
.statics{
    width: 100%;
    min-height: 100px;
    background-color: #fff;
    padding:0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.statics .box{
    width: calc(100% / 4 - 10px);
    margin: 0 ;
    background-color: #f3f4f6;
    min-height: 100px;
    /* max-height: 100px; */
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 1rem;
    position: relative;
    transition: 0.3s;
}

.iconBox{
    padding: 0.5rem;
    border: 1px solid #111926;
    width:40px;
    height: 40px;
    text-align: center;
    border-radius: 8px;
    display: block;
}
.iconBox i{
    font-size: 20px;
    color: #111926;
}
.overviewText{
    display: block;
    width: 100%;
    margin: 10px 0 5px 0;
}
.overviewText .titleText{
    font-size: 13px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    color: #111926;
    display: block;
}
.overviewText .ordersCount{
    font-size: 28px;
    font-weight: 900;
    font-family: 'Noto Sans Hebrew';
    color: #111926;
    display: block;
}
.staticBtn{
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    padding: 5px 10px;
    background-color: #111926;
    font-size: 13px;
    border-radius: 6px;
    font-weight: 400;
    text-decoration: none;
    color: #f7f7f5;
    letter-spacing: 0.5px;
}
.statics .box:hover{
    background-color: #111926;
}
.statics .box:hover .iconBox,
.statics .box:hover .iconBox i
,.statics .box:hover .staticBtn{
    background-color: #3d3d4e;
    color: #fff;
}
.statics .box:hover .overviewText .titleText ,
.statics .box:hover .overviewText .ordersCount{
    color: #fff;
}
.section2 ,
.section3{
    width: 100%;
    min-height: 100px;
    background-color: transparent;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    /* align-items: flex-start; */
}
.section3{
    padding: 0 1rem;
}
.stockData
,.newSupplier{
    width:25% ;
    min-height: 210px;
    padding: 1rem;
    background-color: #f5f5f5;
    border-radius: 8px;
    border: #e0e0e0 1px solid;
    padding-bottom: 10px;
}
/* BUTTON COLOR BLUE ---    #0c75ff */
.newSupplier{
    padding: 0;
    background-color: #fff;
}
.stockData .iconBox{
    background-color: #fff;
}
.stockList{
    margin: 10px 0;
}
.itemList{
    padding: 0.5rem 0;
    background-color: #f1f1f1;
    border: #ccc 1px solid ;
    border-radius: 4px;
    padding-right: 10px;
    margin-top: 5px;
    font-size: 14px;
    font-family: 'Noto Sans Hebrew';
}
/* .iconBox .stockIcon{
    color: #d11a2a;
} */
.lastPayments{
    width: 73.5%;
    min-height: 50px;
    background-color: #fff;
    border: #e0e0e0 1px solid;
    border-radius: 8px;
    overflow: hidden;
}
.lastPayments .header ,
.newSupplier .header ,
.lastOrders .header
{
    width: 100%;
    /* height: 60px; */
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    padding: 1rem;
    position: relative;
}
.lastPayments .header .icon ,
.newSupplier .header .icon ,
.lastOrders .header .icon
{
    padding: 0.5rem;
    border: 1px solid #e0e0e0;
    width:40px;
    height: 40px;
    text-align: center;
    border-radius: 8px;
    background-color: #fff;
}
.lastPayments .header .icon i,
.newSupplier .header .icon i,
.lastOrders .header .icon i{
    font-size: 20px;
    color: #1c1c1c;
}
.lastPayments .header .text,
.newSupplier .header .text,
.lastOrders .header .text{
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    color: #707070;
    margin-right: 10px;
}
.lastPayments .header .searchDiv,
.lastOrders .header .searchDiv
{
    position: absolute;
    left: 1rem;
}
.lastPayments .header .searchDiv input ,
.lastOrders .header .searchDiv input{
    width: 280px;
    border-radius: 8px;
    border:1px solid #e0e0e0;
    padding: 0.3rem 1rem;
    font-size: 13px;
    font-weight: 400;
    color: #707070;
    background-color: #f5f5f5;
    font-family: 'Noto Sans Hebrew';

}
.lastPayments table{
    border-collapse: collapse;
    width: 100%;
}
.lastOrders table {
    border-collapse: collapse;
    width: 100%;
}
th{
    color: #1c1c1c;
}
th, td {
  padding: 8px;
  text-align: right;
  border-bottom: 1px solid #ddd;
  font-family: 'Noto Sans Hebrew';
  font-size: 13px;

}
.lastOrders{
    width:100% ;
    min-height: 50px;
    background-color: #fff;
    border: #e0e0e0 1px solid;
    border-radius: 8px;
    overflow: hidden;
}

tr:hover {background-color: #fcfcfc;}

.fieldsContainer{
    padding: 1rem;
}
.inputsFields{
    width: 100%;
}
.inputsFields label{
    display: block;
    font-size: 13px;
    font-weight: 500;
    font-family: 'Noto Sans Hebrew';
    color: #1c1c1c;
}
.inputsFields input{
    display: block;
    font-size: 13px;
    font-weight: 500;
    font-family: 'Noto Sans Hebrew';
    color: #707070;
    width: 100%;
    padding: 0.5rem ;
    margin-top: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}
.btnFields button{
    display: block;
    font-size: 13px;
    font-weight: 500;
    font-family: 'Noto Sans Hebrew';
    color: #fff;
    width: 33%;
    padding: 0.5rem ;
    margin-top: 10px;
    border: 1px solid #0c75ff;
    border-radius: 8px;
    float: left;
    background-color: #0c75ff;
}


@media  screen and (max-width:1180px){
    .staticBtn {
    top: 1rem;
    bottom: auto;
    }
}




/*   --------------------   */

/* @supports (-webkit-touch-callout: none) { */
  

@media  screen and (max-width:500px){
    .mobile-reports{
        display: flex;
        padding: 1rem;
        flex-direction: column;
        width: 100%;
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
        background-color: #014342;
        margin-top:-1rem;        
    }
    .mobile-reports .welcome{
        display: flex;
        color: #ccc;
        align-items: center;
        width: 100%;
    }
    .mobile-reports .welcome span{
        color: #fff;
    }
    .mobile-reports .welcome b{
        color: #76E6B6;
        margin-right: 5px;
    }
    .mobile-reports .reports,
    .mobile-reports .quick-actions{
        margin-top: 1rem ;
    }
    .mobile-reports .quick-actions{
        margin-bottom: 2rem;
    }
    .mobile-reports .reports-list,
    .mobile-reports .actions-list{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .mobile-reports .reports-list .reports-item{
        width: calc(100% / 2 - 8px);
        padding: 1rem;
          backdrop-filter: blur(10px); /* تغبيش الخلفية */
  -webkit-backdrop-filter: blur(10px); /* دعم سفاري */
  background-color: rgba(0, 0, 0, 0.3); /* لون شفاف قليلاً */
        border-radius: 10px;
    }
    .reports-item .report-title{
        font-size: 14px;
        color: #fff;
    }
    .reports-item .report-data{
        font-size: 30px;
        color: #76E6B6;
    }
    .mobile-reports .quick-actions .quick-title{
        color: #FFF;
        margin-bottom: 1rem;
    }
    .mobile-reports .quick-actions .actions-list .action-item{
        width: 70px;
        display: flex;
        flex-direction: column;
        text-align: center;
    }
    .action-item .action-box{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #76E6B6;
        color: #014342;
        width: 70px;
        height: 70px;
        border-radius: 10px;
    }
    .action-item span{
        color: #fff;
        font-size: 11px;
        margin-top: 5px;
    }
    .panel .ordersPanel{
        width: 100%;
        min-height: 200px;
        background-color:#fff;
        border-radius: 8px;
        border: 1px solid #eee;
        margin: 0 5px;
    }
    .panel .notesPanel{
        width: 100%;
        min-height: 200px;
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid #eee;
        margin: 0 5px;
        float: right;
        display: none;
    }
    .orderImg{
        float: right;
        position: relative;
        margin-left: 10px;
        margin-top: 10px;
    }
    .orderImg img{
        width: 50px;
        height: 50px;
        border-radius: 0px;
    }
    .ordername{
        display: block;
        font-size: 14px;
        font-weight: bold;
        color: #313131;
        font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    }
    .orderDetails{
        margin-top: 5px;
        font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
        font-weight: 400;
        font-size: 12px;
        color: #666666;
    }
    .addedTime{
        position: absolute;
        left: 10px;
        top: 85px;
        color: #666;
        font-size: 12px;
    }
     .statics{
            width: 100%;
    min-height: 100px;
    background-color: #fff;
    padding: 0 1rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    display: none;
    }
    .statics .box{
        width: calc(98% / 2 );
        margin: 5px 0;
        background-color: #fff;
        min-height: 100px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        padding: 1rem;
        position: relative;
        float: right;
    } 
    .staticBtn {
    top: 1rem;
    bottom: auto;
    }
    .section2, .section3 {
    width: 100%;
    min-height: 100px;
    background-color: transparent;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    }
    .stockData ,.lastPayments, .newSupplier{
        width: 100%;
        margin-top: 10px;
    }
    .lastPayments .header .searchDiv input, .lastOrders .header .searchDiv input {
        width: 195px;
    }
    .lastOrders table {
  border-collapse: collapse;
  display: block;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0 auto;
  overflow-x: auto;
  white-space: nowrap;
}

/* } */

}


  .overViewDashboard{
      width: 99%;
      height: 600px;
      float: right;
      margin: 5px 10px;
      border-radius: 5px;
  }
  table{
    width: 100%;
    border: 1px solid #f5f5f5;
    padding: 10px;
    border-spacing: 0;
  }
  .thead-style{
    background-color: #f9f9f9;
    height: 30px;
    padding: 5px;
    border: none;

  }
  .thead-style th{
    padding: 5px ;
    font-size: 14px;
    font-weight: 500;
  }
  tbody td{
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    border: 0;
    font-family: 'Noto Sans Arabic';
  }
  .Done {
    color: #1c1c1c;
    background-color: rgba(201, 242, 155, 0.3);
  }
  .orderOverview{
      width: 100%;
      height: 600px;
      background-color: #fff;
      border-radius: 5px;
      overflow: hidden;
  }
  .orderBoxTitle{
      background-color: #1c1c1c;
      width: 100%;
      height: 70px;
      padding: 0 20px;
  }
  .orderBoxTitle h1{
      font-size: 16px;
      font-weight: 500;
      line-height: 70px;
      float: right;
      width: 50%;
      color: #fff;
      text-align: right;
  }
  .orderSearch{
      float: left;
      width: 50%;
      padding: 17px 0;
  }
  .orderSearch input{
      width: 100%;
      height: 37px;
      border-radius: 5px;
      border: none;
      color: #fff;
      background-color: rgba(255, 255, 255, 0.1);
      padding-right: 10px;
      transition: 0.5s;
      outline: none;
  }
  .orderSearch input:focus{
      background-color: rgba(255, 255, 255, 0.8);
      color: #313131;
  
  }
  .lastorders{
      width: 100%;
      height: 80%;
      background-color: transparent;
      padding: 10px;
      overflow-y: scroll;
  }
  .lastorders .order-long-card{
      width: 100%;
      height: 100px;
      background-color: #fff;
      /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
      margin-top: 10px;
      overflow:hidden ;
      border:  1px solid #ccc;
      
  }
  .lastorders .data-field{
      width: calc( 100% / 8 - 10px);
      height: 80px;
      background-color: #fff;
      margin: 0 5px;
      float: right;
      padding: 20px 5px;
      position: relative;
  }
  .lastorders .data-field span{
      font-size: 13px;
      font-weight: 400;
      color: #707070;
      font-family: 'Noto Sans Hebrew';
  
  }
  .lastorders .data-field p{
      font-size: 15px;
      font-weight: 500;
      color: #313131;
      font-family: 'Noto Sans Hebrew';
  
  }
  .data-field button{
      margin-top:5px;
      width: 80%;
      height: 30px;
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      font-size: 12px;
  
  }
  .data-field .removeOrder{
      color: #707070;
      position: absolute;
      top: 10px;
      left: 10px;
      cursor: pointer;
  }
  .acceptingLabel{
      width: 100%;
      height: 20px;
      background-color: #f5f5f5;
      float: right;
  }
  .acceptingLabel .createdDate{
      font-size: 12px;
      line-height: 20px;
      padding:  0 10px;
      color: #707070;
      font-family: 'Noto Sans Hebrew';
  }
  /* .addNoteContainer{
      width: 100%;
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .addNoteBox, .addOrderBox{
      width: 400px;
      min-height: 200px;
      background-color: #fff;
      border-radius: 10px;
      padding:50px 20px;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 10px;
      
  }
  .addNoteBox .addNoteBoxTitle,
  .addOrderBox .addNoteBoxTitle{
      width: 100%;
      text-align: center;
  }
  .addNoteBox .addNoteBoxTitle h1,
  .addOrderBox .addNoteBoxTitle h1{
      font-size: 18px;
      margin-bottom: 10px;
      font-weight: 700;
  }
  .addNoteBox .noteTxtField,
  .addOrderBox .orderTxtField
  {
      width: 100%;
      text-align: center;
  }
  .addNoteBox .noteTxtField textarea{
      resize: none;
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      font-size: 14px;
      padding: 5px 10px;
      width: 80%;
      margin-top: 5px;
      text-align: right;
  }
  .addOrderBox .orderTxtField input{
      resize: none;
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      font-size: 14px;
      padding: 5px 10px;
      width: 80%;
      margin-top: 5px;
      height: 40px;
      text-align: right;
  }
  .addOrderBox .orderTxtField select{
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      font-size: 14px;
      padding: 5px 10px;
      width: 80%;
      margin-top: 5px;
      height: 40px;
      text-align: right;
  }
  .addOrderBox .orderTxtField .Col-3{
      width: calc(80% / 2 - 1px);
      font-size: 13px;
  }
  .addNoteBox .noteBtnField{
      width: 100%;
      text-align: center;
      margin-top: 5px;
  }
  .addNoteBox .noteBtnField input{
      width: 80%;
      height: 37px;
      background-color: #313131;
      border-radius: 5px;
      border: none;
      color: #fff;
  }
  .notesBox{
      float: right;
      width: 21%;
      height: 600px;
      border-radius: 5px;
      background-color: #313131;
      margin: 5px 0;
      padding: 5px;
      overflow: hidden;
  }
  .notesBox .notesTitle {
      line-height: 50px;
      width: 100%;
      color: #fff;
      background-color: transparent;
      border-bottom: 1px solid #707070;
  }
  .notesBox .notesTitle h2 {
      padding-right: 10px;
      font-size: 16px;
      font-weight: 500;
      font-family: 'Heebo';
  }
  .notesBox #content{
      width: 100%;
      height: 540px;
      background-color: transparent;
      overflow-y: scroll;
      padding: 10px;
  }
  
  .notesBox #content p{
      float: right;
      width: 85%;
      font-size: 14px;
      line-height: 30px;
      padding-left: 10px;
      margin-top: 10px;
  }
  #content .note .span{
      float: left;
      width: 15%;
      font-size: 22px;
      color: red;
      top: 15px;
      left:0px;
      position: absolute;
      cursor: pointer;
  }
  .note{
      background-color:rgba(255, 255, 255, 0.05);
      width: 100%;
      min-height: 60px;
      margin-top: 5px;
      padding: 5px 10px;
      text-align: right;
      font-size: 13px;
      color: #fff;
      border-radius: 7px;
      float: right;
      position: relative;
      /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; 
  }
  .noteDate{
      color: #707070;
      text-align: right;
  }
  */

  </style>
  


// WEBPACK FOOTER //
// src/pages/Home.vue